// If you don't want to use TypeScript you can delete this file!
import React from "react"
import { PageProps, Link, graphql } from "gatsby"

import Layout from "../../../components/layout"
import SEO from "../../../components/seo"

import './index.scss'
import ApiLogo from "../../../components/images/logo.api"
import GoToInstall from "../../../components/widgets/goToInstall"
import { CodeBlock } from "../../../components/widgets/codeBlock"
import { usuarioScripts } from "../../../scripts/usuarios"
import SectionNavigate from "../../../components/widgets/sectionNavigate"

type DataProps = {
    site: {
        buildTime: string
    }
}

const ApiReferenciaLanding: React.FC<PageProps<DataProps>> = ({ data, path, location }) => (
    <Layout isApi={true} location={location}>
        <SEO title="FiscalPOP para eCommerce" />
        <div id='ApiDocs' className="_DOCS withSide">
            <div className="content">
                <h2>Registrar usuario</h2>
                <p>
                    <b>Los usuarios son las cuentas principales que manejan 1 o más emisores, </b>esta sería la cuenta principal de tu integración y la que registrará a todos los emisores (Clientes), quienes son los RFCs que emiten facturas.
                </p>
                <pre>
                    <code>
                    <b>POST:</b> https://api.fiscalpop.com/api/v1/registration/signup
                    </code>
                </pre>
                <h3>
                    Campos de la solicitud
                </h3>
                <ul className="request">
                    <li>
                        <p>
                            <b>name: </b> Nombre de tu usuario, cuenta u empresa.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>email: </b> Correo de contacto, donde nos comunicaremos contigo.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>password: </b> Tu contraseña de acceso al Dashboard (dashboard.fiscalpop.com).
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>phone: </b> Telefono de contacto para seguridad. <br />
                            <span className="small quote">El teléfono jamás es compartido, solo se usa para comunicación urgente</span>
                        </p>
                    </li>
                </ul>
                <h3>
                    Campos de la Respuesta
                </h3>
                <ul className="request">
                    <li>
                        <p>
                            <b>name: </b> Nombre de tu usuario, cuenta u empresa.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>email: </b> Correo de contacto, donde nos comunicaremos contigo.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>password: </b> Tu contraseña de acceso al Dashboard (dashboard.fiscalpop.com).
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>phone: </b> Telefono de contacto para seguridad.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>createdAt: </b> Fecha de creación de la cuenta
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>masterToken: </b> Esta es <span className="error">la llave de acceso principal</span>, tu app no debe exponerla 
                            públicamente, ya que es el token que crea, edita y destruye las cuentas de emisores, así como controlar su billing y datos privados. <br />
                            <span className="small quote">El master token controla cuentas, pero no se utiliza para facturar, para eso cada cuenta tiene su homólogo AuthToken que verás más adelante</span>
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>planType: </b> La clave de Plan que está registrada. Todas las cuentas nuevas comienzan con PlanType: 0
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>credit: </b> Crédito inicial de la cuenta, todas comienzan con 0.
                        </p>
                    </li>
                    <li>
                        <p>
                            <b>emailValid: </b> Si tu correo ya fué validado, todas comienzan con false.
                        </p>
                    </li>
                </ul>
                <SectionNavigate next={`/api/referencia/usuarios-validar`} previous={null}/>
            </div>
            <div className="side">
                <CodeBlock title="Registrar usuario" requests={usuarioScripts.registro.requests} response={usuarioScripts.registro.response}  />
            </div>
        </div>
    </Layout>
)

export default ApiReferenciaLanding
